export const Constants = {
    CORDRA_SCHEMA_KEYWORD: 'cordra',
    OLD_REPOSITORY_SCHEMA_KEYWORD: 'net.cnri.repository'
};
